import { Component } from '@angular/core';

@Component({
  selector: 'gforge-feedback',
  template: `<svg version="1.1" id="feedback-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 640 117">
    <title>GForge Group Logo</title>
    <g>
      <g>
        <path class="gforge-logo__accent" d="M70.5,25.5c-7-1.5-11.4-8.4-10-15.4c1.5-7,8.4-11.4,15.4-10c7,1.5,11.4,8.4,10,15.4
          C84.3,22.5,77.4,27,70.5,25.5z M74.2,7.9c-2.7-0.6-5.4,1.2-6,3.9c-0.6,2.7,1.2,5.4,3.9,6c2.7,0.6,5.4-1.2,6-3.9
          C78.7,11.2,76.9,8.5,74.2,7.9z"/>
      </g>
      <g>
        <path class="gforge-logo__accent" d="M30.8,71.3c-15.4,0-28-12.5-28-28c0-15.4,12.5-28,28-28c15.4,0,28,12.5,28,28C58.7,58.8,46.2,71.3,30.8,71.3
          z M30.8,23.3c-11.1,0-20.1,9-20.1,20.1c0,11.1,9,20.1,20.1,20.1c11.1,0,20.1-9,20.1-20.1C50.8,32.3,41.8,23.3,30.8,23.3z"/>
      </g>
      <g>
        <path class="gforge-logo__accent" d="M43.2,117.1c-11.3,0-20.6-9.2-20.6-20.6c0-11.3,9.2-20.6,20.6-20.6c11.3,0,20.6,9.2,20.6,20.6
          C63.8,107.9,54.6,117.1,43.2,117.1z M43.2,83.8c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7c7,0,12.7-5.7,12.7-12.7
          C55.9,89.5,50.2,83.8,43.2,83.8z"/>
      </g>
      <path class="gforge-logo__prime" d="M61.3,17.9L52,25.2c1.7,2,3.1,4.2,4.2,6.7l10.2-8C64.1,22.5,62.3,20.4,61.3,17.9z M22.7,94.9
        c-8.3-0.7-14.9-7.7-14.9-16.1c0-4.8,2.1-9.3,5.8-12.4l0.6-0.4c-2.2-1.6-4.1-3.5-5.7-5.6C3.1,64.9,0,71.6,0,78.7
        c0,13.1,10.6,23.8,23.6,24.1c-0.6-2-1-4.1-1-6.3C22.7,96,22.7,95.4,22.7,94.9z"/>
    </g>
  </svg>`
})
export class GForgeFeedbackComponent { }
